import React, { PureComponent } from 'react';
import { Form, Slider, Button } from 'antd';
import { FormItemLayout, ConfigFormDecorator } from '../../tools';
import ShowcaseLayout from './showcase-layout';
import './index.less';
const FormItem = Form.Item;
/**
 * 辅助橱窗-配置表单
 */

const templates = [
    {
        id: '1',
        name: '2左2右',
        left: '0px',
    },
    {
        id: '2',
        name: '1左2右',
        left: '20px',
    },
    {
        id: '3',
        name: '1上2下',
        left: '20px',
    },
    {
        id: '4',
        name: '1左3右',
        left: '20px',
    },
];

class ShopWindowCom extends PureComponent<any> {
    changeStyle = (e) => {
        const newValue = e.target.value;
        const {
            form: { setFieldsValue },
        } = this.props;
        setFieldsValue({ entry: new Array(3), showStyle: newValue });
    };

    handleChangeStyle = (item: object) => {
        const { form, onChange } = this.props;
        const formValue = form.getFieldsValue();

        onChange({ ...formValue, ...item });
    };

    render() {
        const {
            form: { getFieldDecorator, getFieldValue },
            uploadAction,
            sourceRoot,
            linkTypes,
            linkTypeMode,
            selector,
            value,
        } = this.props;
        const formItemLayout = FormItemLayout;
        const tmpIndex = value.showStyle || '1';

        return (
            <Form className="showcase-form">
                <FormItem {...formItemLayout} label="选择模板">
                    {[
                        getFieldDecorator('showStyle', {}),
                        templates.map((item) => (
                            <Button
                                type={tmpIndex === item.id ? 'primary' : 'default'}
                                shape="round"
                                style={{ marginLeft: item.left }}
                                key={item.id}
                                onClick={() => this.handleChangeStyle({ showStyle: item.id })}
                            >
                                {item.name}
                            </Button>
                        )),
                    ]}
                </FormItem>
                <FormItem {...formItemLayout} label="布局">
                    {getFieldDecorator('entry', { initialValue: new Array(4) })(
                        <ShowcaseLayout
                            uploadAction={uploadAction}
                            sourceRoot={sourceRoot}
                            selector={selector}
                            linkTypes={linkTypes}
                            linkTypeMode={linkTypeMode}
                            showStyle={getFieldValue('showStyle')}
                        />
                    )}
                </FormItem>

                {/* <FormItem {...formItemLayout} label={'高度比例'}>
                    {getFieldDecorator('height', { initialValue: 200 })(
                        <Slider max={350} min={70} />
                    )}
                </FormItem>

                <FormItem {...formItemLayout} label="图片左右间隙">
                    {getFieldDecorator('imgSidesMargin', { initialValue: 16 })(
                        <Slider max={80} min={0} />
                    )}
                </FormItem>

                <FormItem {...formItemLayout} label="图片上下间隙">
                    {getFieldDecorator('imgUDMargin', { initialValue: 16 })(
                        <Slider max={80} min={0} />
                    )}
                </FormItem> */}

                <FormItem {...formItemLayout} label="页面间距">
                    {getFieldDecorator('margin', { initialValue: 16 })(<Slider max={80} min={0} />)}
                </FormItem>
            </Form>
        );
    }
}

export const ShopWindow = ConfigFormDecorator(ShopWindowCom);
